<template lang='pug'>
  div
    v-card
      v-card-title.font-weight-bold.text-h5(style="justify-content: center;")
        | {{$t('ENTRAIDSYNC.TITLE')}}
      v-card-text.d-flex.justify-between.align-center
        .left-text(style='font-size:16px;color:#444')
          br
          | {{$t('ENTRAIDSYNC.INSTRUCTION')}}
        v-text-field.ml-auto.pa-0.pt-1.mr-2.flex.justify-end(v-model='searchAdfsUsers' flat dense height='30' min-height='30' prepend-inner-icon='icon-search' style="max-width: 300px;")
        span(style='font-size:16px;color:#444') {{$t('ENTRAIDSYNC.SELECTED')}} {{ selected.length }}/{{ users.length }}
      .table-container(style="width: 95%; max-height: 600px; overflow-y: auto; margin: 0 auto;")
        v-data-table(
          v-model="selected"
          :headers="headers"
          :items="users"
          :items-per-page="itemPerPage"
          :page.sync='page'
          item-key="email"
          fixed-header
          @page-count='pageCount = $event' 
          :search='searchAdfsUsers' 
          show-select
          :item-disabled="isRowSelectDisabled"
          height="400px"
          checkbox-color = "#14C6DE"
          hide-default-footer
        )
          template(v-slot:item.sync="{ item }")
            v-checkbox.entra_checkbox(v-model="item.sync" hide-details="auto" :readonly="true" color="#A6E7F0")
          template(v-slot:item.portal_user_selection="{ item }")
            v-checkbox.entra_checkbox(
              v-model="item.portal_user_selection"
              hide-details="auto"
              :readonly="isPortalDisabled(item)"
              :color="isPortalDisabled(item) ? '#A6E7F0' : '#14C6DE'"
            )
        v-pagination.py-1.mb-3(v-model='page' :length='pageCount' circle :total-visible="10")
      v-card-actions.gray-bg-with-border
        v-spacer
        v-btn(:ripple="false",
              @click="onCancel",
              :disabled="loading",
              width="100",
              height="40",
              color="cancel",
              depressed,
              outlined,
              style='font-weight: 700;') Cancel
        v-btn(:ripple="false",
              @click="onConfirm",
              :loading="loading",
              :disabled="loading",
              width="100",
              height="40",
              color="#14C6DE",
              depressed,
              :dark="!loading",) Confirm
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
</template>

<script>
import PersonalSettingService from "@/services/PersonalSettingService";
import i18n from '/common/plugins/vue-i18n.js';
import successDialog from '@/components/Dialog/successDialog';
import errorDialog from '@/components/Dialog/errorDialog';

export default {
  props: {
    users: {
      type: Array,
      default: () => []
    },
    defaultSelect: {
      type: Number,
      default: 0
    }
  },
  components: {
    successDialog,
    errorDialog,
  },
  data() {
    return {
      searchAdfsUsers:'',
      selected: [],
      page: 1,
      pageCount: 0,
      itemPerPage: 100,
      loading: false,
      successDialog: false,
      errorDialog: false,
      errorMessage: '',
    }
  },
  computed: {
    headers() {
      return [
        { value: "data-table-select",align: "center", width: '50px' },
        { text: i18n.t('ENTRAIDSYNC.EMAIL'), value: 'email', width: '260px' },
        { text: i18n.t('ENTRAIDSYNC.FIRST_NAME'), value: 'first_name' },
        { text: i18n.t('ENTRAIDSYNC.LAST_NAME'), value: 'last_name' },
        { text: i18n.t('ENTRAIDSYNC.JOB_TITLE'), value: 'job_title' },
        { text: i18n.t('ENTRAIDSYNC.BUSINESS_PHONES'), value: 'business_phones' },
        { text: i18n.t('ENTRAIDSYNC.OFFICE_LOCATION'), value: 'office_location' },
        { text: i18n.t('ENTRAIDSYNC.SYNC'), value: 'sync', width: '120px' },
        { text: i18n.t('ENTRAIDSYNC.PORTAL_USER'), value: 'portal_user_selection', width: '150px' }
      ]
    }
  },
  watch: {
    loading(val) {
      this.$emit('syncLoading', val);
    },
    selected(newVal) {
      const selectedSet = new Set(newVal.map(i => i.email))

      this.users.forEach(user => {
        const isSelected = selectedSet.has(user.email)
        if (user.sync === false) {
          if (isSelected) {
            user.portal_user_selection = true
          } else {
            user.portal_user_selection = false
          }
        }
      })
    }
  },
  methods: {
    isRowSelectDisabled(item) {
      return item.sync;
    },
    isPortalDisabled(item) {
      if (item.sync && item.is_portal_user) return true;
      if (!item.sync && !this.selected.some(s => s.email === item.email)) return true;
      return false;
    },
    onCancel() {
      this.$emit('closeSyncDialog')
    },
    async onConfirm() {
      let lang = window.localStorage.getItem('language');
      this.loading = true;
      let hasSuccess = false;

      for (const item of this.selected) {
        if (!item.sync) {
          const payload = {
            ...item,
            usersetting: { is_portal_user: item.portal_user_selection }
          };
          await PersonalSettingService.createUserDetail(payload, lang).then(() => {
            hasSuccess = true;
          }).catch((e) => {
            if (e.response.data.error == 'Users reach the upper limit') {
              this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR'));
            } else if (e.response.data.error == 'User already existed') {
              this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR_3'));
            } else {
              console.log(e.response.data.error);
            }
          });
        }
      }

      const toUpdatePortal = this.users.filter(
        item => item.sync && !item.is_portal_user && item.portal_user_selection
      );
      for (const item of toUpdatePortal) {
        if (item.user_id) {
          await PersonalSettingService.updateUserDetail({
            id: item.user_id,
            usersetting: { is_portal_user: true }
          }).then(() => {
            hasSuccess = true;
          }).catch(e => console.log(e));
        }
      }

      this.loading = false;
      if (hasSuccess) {
        this.showSuccessDialog();
      } else {
        this.$emit('closeSyncDialog');
      }
    },
    showSuccessDialog() {
        this.successDialog = true;
    },
    async onEmitSuccessDialog() {
        this.successDialog = false;
        this.$emit('closeSyncDialog');
    },
    showErrorDialog(message) {
        this.errorDialog = true;
        this.errorMessage = message;
    },
    onEmitErrorDialog() {
        this.errorDialog = false;
    },
  }
}
</script>

<style scoped>
.gray-bg-with-border {
  background-color: #f5f5f5; /* 淺灰底 */
  border-top: 1px solid #ddd; /* 頂部底線 */
}
.entra_checkbox {
  margin: 0; 
  padding: 0px 0px;
  background-color:  rgba(255, 255, 255, 0) !important;
  align-items: center;
  justify-content: center;
}
</style>